export default {
  props: {
    currentPage: {
      type: Number,
      required: false,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    itemsCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    getCurrentPage() {
      return this.currentPage;
    },
    totalPages() {
      return Math.ceil(this.itemsCount / this.pageSize);
    },
    canPaginatePrev() {
      return this.currentPage > 1;
    },
    canPaginateNext() {
      return this.currentPage < this.totalPages;
    },
  },
  methods: {
    paginate(direction) {
      if (direction === 'prev') {
        if (this.currentPage > 1) {
          this.$emit('page-changed', this.currentPage - 1);
        }
      } else if (direction === 'next') {
        if (this.currentPage < this.totalPages) {
          this.$emit('page-changed', this.currentPage + 1);
        }
      }
    },
  },
};
